import { useMemo } from 'react';

import { useGetExternalOffersQuery } from '@ocx/graphql';
import { Offer } from '../../../../modules/offers/offer.types';
import { useDisplayCategories } from '../../../../modules/loyalty/useDisplayCategories';
import { groupOfferAndCategories } from './offers-carousel.utils';
import { createExternalOffersQueryVariables } from '../../../../modules/external-loyalty/external-offers.utils';

export const useOffersCarouselCategories = (offers: Offer[]) => {
  const { displayCategories: categories, loading: categoriesLoading } = useDisplayCategories();

  const variables = useMemo(() => createExternalOffersQueryVariables(categories), [categories]);
  const skipExternal = !variables?.filter.bannerConfigurationUuidIncludes.length;
  const { data: externalBanners, loading: externalLoading } = useGetExternalOffersQuery({
    skip: skipExternal,
    variables,
  });

  const grouped = useMemo(
    () => groupOfferAndCategories(categories, offers, externalBanners?.banners),
    [offers, categories, externalBanners?.banners],
  );

  // The selected tab is always the first category in the list. In this case, when the app fetched banners,
  // it made them the selected tab the first element because there was only these categories in the list
  // at that moment. Then, when the app fetched the rest of the categories, the banner category was already selected.
  // The categories query is slow, whereas the banners query is fast. That is the reason why the first
  // render only has one category from banners, which the app makes preselected by default.
  // So we use loading as an indicator that both queries fetching is still in progress to wait until will be finished.

  const loading = categoriesLoading || (!skipExternal && externalLoading);

  return { categories: grouped, loading };
};
